import React, { createContext, useContext, useState, useEffect } from 'react';

const ComplianceContext = createContext();

export function useCompliance() {
  const context = useContext(ComplianceContext);
  if (!context) {
    throw new Error('useCompliance must be used within a ComplianceProvider');
  }
  return context;
}

export function ComplianceProvider({ children }) {
  const [hasAcceptedRisk, setHasAcceptedRisk] = useState(false);
  const [showComplianceBanner, setShowComplianceBanner] = useState(false);

  // Check if user has previously accepted the risk disclaimer
  useEffect(() => {
    const accepted = localStorage.getItem('tulidu_risk_accepted');
    if (accepted === 'true') {
      setHasAcceptedRisk(true);
      setShowComplianceBanner(false);
    } else {
      setShowComplianceBanner(true);
    }
  }, []);

  const acceptRisk = () => {
    setHasAcceptedRisk(true);
    setShowComplianceBanner(false);
    localStorage.setItem('tulidu_risk_accepted', 'true');
  };

  const declineRisk = () => {
    setShowComplianceBanner(false);
    // Redirect to a safe page or show alternative content
    window.location.href = '/about';
  };

  const resetCompliance = () => {
    setHasAcceptedRisk(false);
    setShowComplianceBanner(true);
    localStorage.removeItem('tulidu_risk_accepted');
  };

  const value = {
    hasAcceptedRisk,
    showComplianceBanner,
    acceptRisk,
    declineRisk,
    resetCompliance
  };

  return (
    <ComplianceContext.Provider value={value}>
      {children}
    </ComplianceContext.Provider>
  );
}
